module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('testimonies-list', {
    attrs: {
      "globalEnpoint": _vm.globalEnpoint,
      "searchEndpoint": _vm.searchEndpoint,
      "searchEnabled": _vm.searchEnabled,
      "additionalQueryParam": _vm.additionalQueryParam
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Testimonies")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7de421bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Testimonies.vue
// module id = 449
// module chunks = 1